// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__6YCaT","bookNowBtnStyle":"AboutUs_bookNowBtnStyle__3ayUD"};